<template>
  <div class="cash-withdrawal-record">
    <div class="record-card">
      <div class="my-card-title">提现记录</div>
      <div class="table-wrap">
        <el-table :data="list" v-loading="loading" element-loading-text="给我一点时间" :empty-text="emptyText" border fit
          highlight-current-row>
          <el-table-column label="提现账户" align="center" minWidth="150" prop="account">
          </el-table-column>
          <el-table-column label="金额" align="center" width="150" prop="num">
          </el-table-column>
          <el-table-column label="状态" align="center" width="150" prop="status">
          </el-table-column>
          <el-table-column label="申请提现时间" align="center" minWidth="150" prop="apply">
          </el-table-column>
          <el-table-column label="操作完后时间" align="center" minWidth="150" prop="finish">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { getIndex } from "@/api/index";
export default {
  name: 'Withdraw',
  components: {

  },
  data() {
    return {
      loading: true,
      list: [
        {
          account: 321321321321,
          num: 100,
          status: '提现中',
          apply: '2019-01-01 12:00:00',
          finish: '2019-01-01 12:00:00'
        },
        {
          account: 321321321321,
          num: 100,
          status: '提现中',
          apply: '2019-01-01 12:00:00',
          finish: '2019-01-01 12:00:00'
        },
        {
          account: 321321321321,
          num: 100,
          status: '提现中',
          apply: '2019-01-01 12:00:00',
          finish: '2019-01-01 12:00:00'
        },
        {
          account: 321321321321,
          num: 100,
          status: '提现中',
          apply: '2019-01-01 12:00:00',
          finish: '2019-01-01 12:00:00'
        }
      ]
    };
  },
  computed: {

  },
  created() {
    this.getIndex();
  },
  methods: {
    getIndex() {
      getIndex({}).then(res => {

        this.loading = false;
        this.user = res.data;
      }).catch((err) => {

      });
    },
  }
};
</script>

<style lang="scss" scoped>
.cash-withdrawal-record {
  width: 100%;
  padding: 35px 0 227px 0;
  box-sizing: border-box;
  background-color: #F4F8F9;
  display: flex;
  align-items: center;
  flex-direction: column;

  .record-card {
    width: 1001px;
    background: #FFFFFF;
    box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.0196);

    .table-wrap {
      width: 100%;
      padding: 20px 32px;
      box-sizing: border-box;

      .table {
        border: 1px solid #DCE5EB;
      }

      th {
        text-align: center;
        padding: 13px 0;
      }

      thead {
        tr {
          th {
            background-color: #DCE5EB;
          }

          th:nth-child(1) {
            width: 34%;
          }

          th:nth-child(2) {
            width: 12%;
          }

          th:nth-child(3) {
            width: 10%;
          }

          th:nth-child(4),
          th:nth-child(5) {
            width: 22%;
          }
        }
      }

      tbody {
        &>.empty {
          position: relative;
          height: 43px;

          &>th {
            position: absolute;
            width: 100%;
            height: 43px;
            font-size: 15px;
            color: #999999;
          }
        }
      }
    }
  }
}
</style>
